import dayjs from '@srm/ui/lib/dayjs';
import { toLocalDate } from '@srm/ui/lib/toLocalDate';
import { IUserAssistants } from '@models/IUserAssistants';

export type SubstitutionKind = 'permanent' | 'temporary';

/** Активное (или запланированное) замещение, выведенное из ответа getAssistant(). */
export interface IActiveSubstitution {
    /** Ключ заместителя в адресной книге. */
    key: string;
    /** ФИО заместителя. */
    name: string;
    kind: SubstitutionKind;
    /** Только для temporary: сырые границы периода (для форматирования подписи). */
    startDate?: Date | string;
    endDate?: Date | string;
    /** temporary ещё не наступил — дата начала в будущем. */
    scheduled: boolean;
}

/**
 * Сводит ответ getAssistant() к одному активному замещению для показа в меню.
 * Постоянный (уполномоченный) приоритетнее временного — на бэке они взаимоисключающие,
 * но подстраховываемся. ВРИО с истёкшим сроком (endDate раньше сегодняшнего дня) не
 * показываем: логика зеркалит vrioNote из UserHoverCard.
 */
export function deriveSubstitution(data: IUserAssistants | null | undefined): IActiveSubstitution | null {
    if (!data) return null;

    if (data.assistantId) {
        return { key: data.assistantId, name: data.assistantName ?? '', kind: 'permanent', scheduled: false };
    }

    if (data.dummyId) {
        const end = data.dummyEndDate ? dayjs(toLocalDate(data.dummyEndDate)) : null;
        if (end && end.endOf('day').isBefore(dayjs())) return null;

        const start = data.dummyStartDate ? dayjs(toLocalDate(data.dummyStartDate)) : null;
        const scheduled = !!start && start.startOf('day').isAfter(dayjs().startOf('day'));

        return {
            key: data.dummyId,
            name: data.dummyName ?? '',
            kind: 'temporary',
            startDate: data.dummyStartDate,
            endDate: data.dummyEndDate,
            scheduled,
        };
    }

    return null;
}
